// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1AbhV","modalFooterButton":"ModalNotes_modalFooterButton__3g2wQ"};